"use strict";
// Autogenerated by sprite compiler (large sprites)
Object.defineProperty(exports, "__esModule", { value: true });
exports.largeSprites = void 0;
exports.largeSprites = {
    backLizardScales: { k: 'backLizardScales', d: 'goat/dungeondive/crokinole-large', f: 'back-lizard-scales' },
    backSnowflakes: { k: 'backSnowflakes', d: 'goat/dungeondive/crokinole-large', f: 'back-snowflakes' },
    crokinoleBoard2Ink: { k: 'crokinoleBoard2Ink', d: 'goat/dungeondive/crokinole-large', f: 'crokinole-board2-ink' },
    crokinoleBoardInk: { k: 'crokinoleBoardInk', d: 'goat/dungeondive/crokinole-large', f: 'crokinole-board-ink' },
    crokinoleTitle: { k: 'crokinoleTitle', d: 'goat/dungeondive/crokinole-large', f: 'crokinole-title' },
    goatBackgroundBlue3: { k: 'goatBackgroundBlue3', d: 'goat/backgrounds/', f: 'goat-background-blue3' },
    goatBackgroundMenuMain: { k: 'goatBackgroundMenuMain', d: 'goat/backgrounds/x/', f: 'goat-background-menu-main' },
    goatBackgroundMenuMainBattle: { k: 'goatBackgroundMenuMainBattle', d: 'goat/backgrounds/x/', f: 'goat-background-menu-main-battle' },
    startingLineArc: { k: 'startingLineArc', d: 'goat/dungeondive/crokinole-large', f: 'starting-line-arc' },
};
